import { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import SelectField from "../../../../components/common/form/SelectField";
import { computeAssociationVerifiedByColor, createOptionListForSelectTag } from "../../../../helpers/utils/Utils";
import { OptionType } from "../../../../helpers/utils/StyleUtils";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useGetAllStatesQuery } from "../../../data/states/statesApi";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import { useGetAssociationByIdQuery, useUpdateAssociationDetailApiMutation } from "../associationApi";
import IconButton from "../../../../components/common/form/IconButton";
import { FaCheckCircle, FaLink, FaSearch, FaTimes } from "react-icons/fa";
import {formatValueAsDate, formatVerifiedDate} from "../../../../helpers/utils/DateUtils";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { useGetAllCountyByStateIdQuery } from "../../../data/counties/countiesApi";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import CommonSelectorModal from "../../../../components/common/form/CommonSelectorModal";
import { useSearchManagementCompanyApiQuery } from "../../managementCompany/managementCompany";
import { useSearchThirdPartyProviderApiQuery } from "../../thirdPartyProvider/thirdPartyProvider";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { FaMagnifyingGlass } from "react-icons/fa6";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { useUserProfileInfoQuery, useUtilDataQuery } from "../../../profile/profileApi";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import { useDispatch } from "react-redux";
import { tgxApi } from "../../../../app/tgxApi";

interface props {
    isReadOnly?: boolean;
}

const AssociationDetailInfo: FC<props> = ({ isReadOnly }) => {
    const { associationId } = useParams();
    const dispatch = useDispatch();

    const [associationData, setAssociationData] = useState<any>({});
    const { data: associationsData } = useGetAssociationByIdQuery(associationId);
    const { data: enums } = useGetEnumsQuery("");
    const iconButtonStyle = "fa cursor-pointer text-highlight-0 absolute left-auto right-5 top-6";
    const [showButtons, setShowButtons] = useState<boolean>(false);
    const [updateAssociationDetailApi, updateAssociationApiResponse] = useUpdateAssociationDetailApiMutation()
    const [disableCompany, setDisableCompany] = useState(false);
    const [disableProvider, setDisableProvider] = useState(false);
    const statesApiResult = useGetAllStatesQuery("");
    const countiesApiResult = useGetAllCountyByStateIdQuery(associationData?.state?.value || skipToken);
    const [showProviderModal, setShowProviderModal] = useState<boolean>(false);
    const [showManagementCompanyModal, setShowManagementCompanyModal] = useState<boolean>(false);
    const [showVerifiedByModal, setShowVerifiedByModal] = useState(false);
    const [status, setStatus] = useState(null);

    const [selectedRow, setSelectedRow] = useState<any>({});
    const { data: utilData } = useUtilDataQuery("");
    const [verifiedCheck, isVerifiedCheck] = useState(false);
    const { data: userProfileInfo } = useUserProfileInfoQuery("");

    useEffect(() => {
        document.title = associationData?.name
    });


    useEffect(() => {
        if (associationsData) {

            const obj = associationsData;
            const isThirdPartyProviderSet = !!obj?.hoaThirdPartyProvider?.name;
            const isManagementCompanySet = !!obj?.managementCompany;
            setDisableProvider(isManagementCompanySet);
            setDisableCompany(isThirdPartyProviderSet);
            setStatus(obj.status)
            setAssociationData({
                ...obj,
                state: obj?.county ? {
                    label: obj?.county?.state?.stateName || "",
                    value: obj?.county?.state?.id || "",
                } : null,
                county:
                    obj?.county ? {
                        label: obj?.county?.countyName || "",
                        value: obj?.county?.id || "",
                    } : null,

                status: obj?.status
                    ? {
                        value: obj.status,
                        label: getEnumDisplayNameByConstant(
                            enums?.["AssociationStatus"],
                            obj.status
                        ),
                    }
                    : null,
                hoaThirdPartyProvider: obj?.hoaThirdPartyProvider || "",
                managementCompany: obj?.managementCompany || "",
                overrideAssociationStatus: getEnumDisplayNameByConstant(enums?.["AssociationStatus"], obj.hoaThirdPartyProvider?.overrideAssociationStatus || obj.managementCompany?.hoaThirdPartyProvider?.overrideAssociationStatus || obj.managementCompany?.overrideAssociationStatus || null)
            });
        }
    }, [associationsData, enums]);


    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const { name, value } = "target" in e ? e.target : e;
        if (name === "state") {
            setAssociationData((prevData: any) => ({
                ...prevData,
                [name]: value,
                county: null,
            }));
        }
        setAssociationData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
        setShowButtons(true);

    };

    useEffect(() => {
        if (!showVerifiedByModal) {
            isVerifiedCheck(false);
        }
    }, [showVerifiedByModal]);
    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        let obj = {

            name: associationData?.name,
            county: {
                id: associationData?.county?.value,
            },
            managementCompany: associationData?.managementCompany
                ? { id: associationData.managementCompany.id }
                : null,

            hoaThirdPartyProvider: associationData?.hoaThirdPartyProvider
                ? { id: associationData.hoaThirdPartyProvider.id }
                : null,
            verifiedBy: verifiedCheck && userProfileInfo ? userProfileInfo?.username : associationData?.verifiedBy,
            verifiedDate:verifiedCheck
                ? new Date()
                : (associationData?.verifiedDate !== null
                    ? associationData?.verifiedDate
                    : null),
            status: associationData?.status?.value,
            contacts:
                associationData?.contacts


        }
        const UpdateSystemProperty = async () => {
            await updateAssociationDetailApi({
                associationId: associationId,
                requestBody: obj,
            }).unwrap();
        };
        await handleRTKQuery(UpdateSystemProperty, () => {
            setShowButtons(false);
            setShowVerifiedByModal(false)
        });
    }


    const handleOnClick = (e: any, name: string) => {
        e.preventDefault();
        if (name === "hoaThirdPartyProvider") {
            setAssociationData({
                ...associationData,
                [name]: selectedRow
            })
            setShowProviderModal(false)
            setDisableCompany(true)
        } else {
            setAssociationData({
                ...associationData,
                [name]: selectedRow
            })
            setDisableProvider(true)
            setShowManagementCompanyModal(false)
        }
        setShowButtons(true)
    }


    const handleClearField = (fieldName: string) => {
        setAssociationData((prevData: any) => {
            const updatedData = {
                ...prevData,
                [fieldName]: '',
            };
            const isThirdPartyProviderSet = !!updatedData.hoaThirdPartyProvider;
            const isManagementCompanySet = !!updatedData.managementCompany;

            setDisableProvider(isManagementCompanySet);
            setDisableCompany(isThirdPartyProviderSet);

            return updatedData;
        });
        setShowButtons(true)
    };

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }],
        }
    ]

    return (
        <>

            <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md">
                <Form
                    onSubmit={handleSubmit}
                    fields={
                        <>
                            <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2">
                                <h5 className="font-semibold text-surface-0">Association Details
                                </h5>
                                {associationData?.name && associationData?.name.toUpperCase() === "NO MAINTENANCE ASSESSED" &&
                                    <h6 className={"info ml-2"}>(No Verification Required)</h6>}
                                {showButtons && !isReadOnly && (
                                    <ButtonTray
                                        buttons={[
                                            {
                                                buttonProps: {
                                                    btnText: "Cancel",
                                                    onClick: () => {
                                                        dispatch(tgxApi.util.invalidateTags(["associationById"]));
                                                        setShowButtons(false);
                                                    },

                                                    type: "cancel",
                                                },
                                                buttonType: "button"
                                            },
                                            {
                                                buttonProps: {
                                                    btnText: "Submit",
                                                    type: "submit",
                                                    isLoading: (updateAssociationApiResponse.isLoading),
                                                },
                                                buttonType: "button",
                                            }
                                        ]}
                                        align="end"
                                        gap={2}
                                    />
                                )}
                            </div>
                            <div className={'p-2'}>
                                <InputField
                                    name="name"
                                    label="Name"
                                    value={associationData?.name || ""}
                                    onChange={handleOnChange}
                                    required
                                    placeholder="Enter Name..."
                                    labelClassName={'font-medium'}
                                    disabled={isReadOnly}
                                />
                                <SelectField
                                    placeholder="Select State..."
                                    value={associationData?.state}
                                    options={createOptionListForSelectTag(statesApiResult?.data, "stateName", "id")}
                                    onChange={(selectedOption) => handleOnChange({
                                        name: "state",
                                        value: selectedOption
                                    })}
                                    label="State"
                                    required
                                    labelClassName={'font-medium'}
                                    isDisabled={isReadOnly}
                                />

                                <SelectField
                                    placeholder="Select County..."
                                    value={associationData?.county} // Use first county from array
                                    options={createOptionListForSelectTag(countiesApiResult?.data, "countyName", "id")}
                                    onChange={(selectedOption) => handleOnChange({
                                        name: "county",
                                        value: selectedOption
                                    })}
                                    label="County"
                                    required
                                    labelClassName={'font-medium'}
                                    isDisabled={!associationData?.state || isReadOnly}
                                />
                                {status !== "VOLUNTARY" && status !== "INACTIVE" &&
                                    <>
                                        <InputField
                                            name="verifiedBy"
                                            label="Verified By"
                                            icon={
                                                utilData &&
                                                utilData?.customerLevel !== null &&
                                                hasPermission(["ASSOC-U"]) && (
                                                    <IconButton
                                                        icon={
                                                            <FaCheckCircle
                                                                style={{
                                                                    color: computeAssociationVerifiedByColor(
                                                                        associationData?.verifiedDate,
                                                                        utilData?.customerLevel
                                                                    ),
                                                                }}
                                                            />
                                                        }
                                                        onClick={() => {
                                                            isVerifiedCheck(true);
                                                            setShowVerifiedByModal(true);
                                                        }}

                                                    />
                                                )
                                            }
                                            disabled={true}
                                            value={associationData?.verifiedBy || ""}
                                            onChange={handleOnChange}
                                            placeholder="Enter Verified By..."
                                            labelClassName={'font-medium'}
                                        />

                                        <InputField
                                            name="verifiedDate"
                                            label="Verified Date"
                                            disabled={true}
                                            value={formatVerifiedDate(associationData?.verifiedDate)}
                                            onChange={handleOnChange}
                                            placeholder="Enter verifiedDate..."
                                            labelClassName={'font-medium'}
                                        />
                                    </>
                                }
                                <SelectField
                                    placeholder="Select Status..."
                                    value={associationData?.status || null}
                                    options={createOptionListForSelectTag(enums?.["AssociationStatus"], "value", "constant")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({ name: "status", value: selectedOption });
                                        setStatus(selectedOption?.value);
                                    }}

                                    label="Status"
                                    labelClassName={'font-medium'}
                                    isDisabled={associationData?.overrideAssociationStatus || isReadOnly}
                                />

                                {associationData?.overrideAssociationStatus &&
                                    <InputField
                                        name="overrideAssociationStatus"
                                        label="Override Status"
                                        disabled={true}
                                        value={(associationData?.overrideAssociationStatus) || ""}
                                        onChange={handleOnChange}
                                        placeholder="Enter Override Status..."
                                        labelClassName={'font-medium'}


                                    />

                                }
                                <InputField
                                    name="statusSetBy"
                                    label="Status Set By"
                                    disabled={true}
                                    value={associationData?.statusSetBy || ""}
                                    onChange={handleOnChange}
                                    placeholder="Enter status set by..."
                                    labelClassName={'font-medium'}

                                />
                                <InputField
                                    name="managementCompany"
                                    label="Management Company"
                                    onChange={handleOnChange}
                                    value={associationData?.managementCompany?.name || ""}
                                    type="text"
                                    disabled={disableCompany || isReadOnly}
                                    placeholder="Enter Management Company..."
                                    onClick={() => {
                                        setShowManagementCompanyModal(true);
                                    }}
                                    labelClassName={'font-medium'}
                                    className="cursor-pointer"
                                    icon={<IconButton
                                        icon={<FaLink onClick={() => {
                                            if (selectedRow?.id && !disableCompany) {
                                                window.open(`/management-companies/${selectedRow.id}`, '_blank');
                                            }
                                        }} />
                                        }
                                        className={`text-sm ${associationData?.managementCompany ? 'text-highlight-4' : 'text-surface-4 cursor-default'
                                            }`}
                                        title={"Create Management Company"}

                                    />}
                                    inputIcon={
                                        !disableCompany && (
                                            disableProvider ? (
                                                <FaTimes
                                                    className={iconButtonStyle}
                                                    title="Clear Management Company"
                                                    onClick={() => handleClearField("managementCompany")}
                                                />
                                            ) : (
                                                <FaSearch
                                                    className={iconButtonStyle}
                                                    title="Add Management Company"
                                                    onClick={() => setShowManagementCompanyModal(true)}
                                                />
                                            )
                                        )
                                    }
                                />
                                <InputField
                                    name="hoaThirdPartyProvider"
                                    label="Third Party Provider"
                                    onChange={handleOnChange}
                                    value={associationData?.hoaThirdPartyProvider?.name || ""}
                                    type="text"
                                    disabled={disableProvider}
                                    placeholder="Enter Third Party Provider..."
                                    labelClassName={'font-medium'}
                                    icon={<IconButton
                                        icon={<FaLink onClick={() => {
                                            if (selectedRow?.id && !disableProvider) {
                                                window.open(`/third-party-providers/${selectedRow.id}`, '_blank');
                                            }
                                        }} />
                                        }
                                        className={`text-sm ${associationData?.hoaThirdPartyProvider ? 'text-highlight-4' : 'text-surface-4 cursor-default'
                                            }`}
                                        title={"Create Third Party Provider"}
                                    />}
                                    onClick={() => {
                                        setShowProviderModal(true);
                                    }}
                                    className="cursor-pointer"
                                    inputIcon={
                                        !disableProvider && (
                                            disableCompany ? (
                                                <FaTimes
                                                    className={iconButtonStyle}
                                                    title="Clear Third Party Provider"
                                                    onClick={() => handleClearField("hoaThirdPartyProvider")}
                                                />
                                            ) : (
                                                <FaSearch
                                                    className={iconButtonStyle}
                                                    title="Add Provider Detail"
                                                    onClick={() => {
                                                        setShowProviderModal(true);
                                                    }}
                                                />
                                            ))
                                    }
                                />
                            </div>


                        </>
                    }
                />
                {showProviderModal &&
                    <CommonSelectorModal
                        title="Third Party Selector"
                        columns={columns}
                        data={useSearchThirdPartyProviderApiQuery}
                        show={showProviderModal}
                        onSubmit={(e: any) => handleOnClick(e, "hoaThirdPartyProvider")}
                        setShow={setShowProviderModal}
                        setSelectedRow={setSelectedRow}
                    />
                }
                {showManagementCompanyModal &&
                    <CommonSelectorModal
                        title="Management Company Selector"
                        columns={columns}
                        data={useSearchManagementCompanyApiQuery}
                        show={showManagementCompanyModal}
                        onSubmit={(e: any) => handleOnClick(e, "managementCompany")}
                        setShow={setShowManagementCompanyModal}
                        setSelectedRow={setSelectedRow}
                    />
                }
                {showVerifiedByModal && <ConfirmationModal title={"Verify Association"}
                    bodyMessage={"Are you sure you want to mark this association as verified?"}
                    onSubmit={handleSubmit}
                    show={showVerifiedByModal}
                    setShow={setShowVerifiedByModal}
                    isLoading={updateAssociationApiResponse.isLoading} />}
            </div>
        </>
    )
};

export default AssociationDetailInfo;